// Import Packages
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

// Import Recoil
import { useSetRecoilState } from 'recoil';
import { saveAvailable } from "../../../../recoil-store/recoil-state";
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";
import {CodeEditor} from "../../../FlowConfigurationInputs/CodeEditor/CodeEditor";


/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function RunCommand({ action, showAlert, variables, setOpenVariable, recorder, variableRender }) {
    const { t } = useTranslation();

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.RUN-COMMAND.';

    useEffect(() => {
        if (!action.fields?.script || action.fields?.script?.value === '') {
            action.fields.script = { value: "" };
        }
    }, [])

    return (
        <div className="conf-field-container">
            <FieldLabel name={t(label + 'COMMAND')} is_required/>
            <CodeEditor action={action} inputName="script" variables={variables} language="powershell"
                        setOpenVariable={setOpenVariable}
                        multiline isRequired hideRequired/>
            <small className='conf-field-desc'><em>{t(label + 'ONLY-POWERSHELL-SCRIPT-ALLOWED')}</em></small>
        </div>
    );
}

export default RunCommand;
